module.exports = __webpack_public_path__ + "assets/img/default-news-small.400837a2.jpg";